<div class="mx-auto text-center p-px-24" *ngIf="!isLoading">
  <p class="fs-20 text-primary">Motif de refus</p>
  <div>
    <p class="text-primary">{{ refuText || "N/A" }}</p>
  </div>
  <app-button text="OK" (click)="dialogRef.close()"></app-button>
</div>
<app-loader *ngIf="isLoading"></app-loader>
